export const DISABLE_SCROLL_DATA_ATTRIBUTE = 'data-disable-scroll';
//# sourceMappingURL=index.js.map